module.exports = __webpack_public_path__ + "static/make-video-slide6-b3302014cef1f8c84903b6b2facf6a64.png";